import React from "react";
import FileUpload from "@/components/FileUpload";
import PhoneInput from "@/components/PhoneInput";

export default function DynamicField({ field, value, onChange, context }) {
  const v = value ?? "";
  const setV = (val) => onChange(field.name, val);

  // Phone fields get the country-code dropdown
  if (field.type === "tel" || /phone/i.test(field.name)) {
    return (
      <div>
        <label className="label-eyebrow block mb-2">{field.label}{field.required && " *"}</label>
        <PhoneInput value={v} onChange={setV} required={field.required} testid={`field-${field.name}`} />
      </div>
    );
  }

  if (field.type === "select") {
    return (
      <div>
        <label className="label-eyebrow block mb-2">{field.label}{field.required && " *"}</label>
        <select
          required={field.required}
          className="input-sharp"
          value={v}
          onChange={(e) => setV(e.target.value)}
          data-testid={`field-${field.name}`}
        >
          <option value="">— Select —</option>
          {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
        {field.note && <p className="text-xs text-black/50 mt-1">{field.note}</p>}
      </div>
    );
  }
  if (field.type === "textarea") {
    return (
      <div>
        <label className="label-eyebrow block mb-2">{field.label}{field.required && " *"}</label>
        <textarea rows={3} required={field.required} className="input-sharp" value={v} onChange={(e) => setV(e.target.value)} data-testid={`field-${field.name}`} />
      </div>
    );
  }
  if (field.type === "file") {
    return (
      <div>
        <label className="label-eyebrow block mb-2">{field.label}</label>
        <FileUpload context={context || "general"} label={field.label} testid={`field-${field.name}`} onUploaded={(data) => setV(data.id)} />
      </div>
    );
  }
  return (
    <div>
      <label className="label-eyebrow block mb-2">{field.label}{field.required && " *"}</label>
      <input
        type={field.type || "text"}
        required={field.required}
        min={field.min}
        placeholder={field.placeholder}
        className="input-sharp"
        value={v}
        onChange={(e) => setV(e.target.value)}
        data-testid={`field-${field.name}`}
      />
      {field.note && <p className="text-xs text-black/50 mt-1">{field.note}</p>}
    </div>
  );
}
